module.exports = __webpack_public_path__ + "static/fire_elemental-ea5d0a8f13c2c7b310c299f0d8f0e297.jpeg";